import useApiQuery from 'shared/hooks/use-api-query';
import {CategoryProps} from '../types';

const useCategoriesByCompanySelect = (companyId?: string) => {
  const {data = [], ...rest} = useApiQuery<CategoryProps[]>({
    url: `/categories/companies/${companyId}/all`,
    enabled: !!companyId,
  });

  return {
    ...rest,
    data: data?.map((category) => ({
      label: category.name,
      value: category.id,
    })),
  };
};

export default useCategoriesByCompanySelect;
